export class BaseClass{
    public Id: number;
    public Designation: string;
}


// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/domain/base.ts